











































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ImageInfo from '@/components/Image/ImageInfo.vue'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import moment from 'moment'
import { uuid, dateFormat, throttle, download } from '@/utils/util'
import RelationOrders from '@/views/AiiTasks/RelationOrders.vue'
import PendingTrack from '../AiiTasks/PendingTrack.vue'
import Task from '@/web-task'
import Info from '@/views/AiiTasks/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import ImageItem from '@/views/AiiTasks/ImageItem.vue'
import ImageList from '@/views/AiiTasks/ImageList.vue'
import StaffInfo from '@/components/task/StaffInfo.vue'
import CancelApply from '@/components/task/CancelApply.vue'
import RecordSection from '@/components/task/RecordSection.vue'
import { getCheckboxSheetValue } from '@/web-task/utils'
import Sign from './Sign.vue'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
let viewer: any = ''
let historyViewer: any = ''

@Component({
	components: {
		ImageInfo,
		RelationOrders,
		PendingTrack,
		Info,
		InfoRow,
		ImageItem,
		ImageList,
		StaffInfo,
		CancelApply,
		RecordSection,
		Sign,
	},
})
export default class AddTask extends Vue {
	@Prop()
	public injured!: any

	@Prop()
	public order!: any

	@Prop()
	private show!: any

	@Prop()
	private activeKey!: any

	private taskInfo: any = []
	private staffInfo: any = []

	private injuredInfo: any = []
	private theInjured: any = []
	private hospitalized: any = []
	private mediate: any = []
	private imageInfo: any = ''

	private injuryInfo: any = []
	private accidentInfo: any = false
	private caregiversInfo: any = false
	private workInfo: any = false
	private livingInfo: any = false
	private familyInfo: any = false
	private agentInfo: any = false
	private caseDelayInfo: any = {}
	private operatorCancelReasonInfo: any = false
	private operatorCancelHistoryInfo: any = false

	private getCancelOrder(index: any) {
		return Math.floor((index + 1) / 2)
	}

	private getCheckboxSheetValue() {
		return getCheckboxSheetValue(...arguments)
	}

	private get mediaInfoMap() {
		const obj: any = {}
		const applyCancels = this.order.applyCancels

		if (applyCancels) {
			const operatorCancel = applyCancels.find(
				(item: any) => item.dataType === 'application'
			)

			if (operatorCancel) {
				const mediaInfoList = operatorCancel.mediaInfoList
				for (const i of mediaInfoList) {
					if (!obj[i.type]) {
						obj[i.type] = []
					}
					obj[i.type].push(i)
				}
			}
		}

		return obj
	}

	@Watch('order', { immediate: true })
	private onOrderChange() {
		const task = new Task({
			propsData: {
				order: this.order,
				injured: this.injured,
				setting: this.$store.state.setting,
			},
		})
		this.taskInfo = task.getTaskInfo()
		this.taskInfo.span = {
			关节活动度复勘部位: 12,
		}
		this.staffInfo = task.getStaffInfo()

		this.theInjured = task.getInjuredInfo()
		this.hospitalized = task.getHospitalized()
		this.injuredInfo = task.getHomeInjuredInfo()
		this.injuredInfo.span = {
			诊断名称: 24,
			现阶段诊疗方案: 24,
			治疗方式: 24,
			三期诊断库: 24,
		}
		this.mediate = task.getMediate()
		this.imageInfo = task.getHomeImageInfo()

		this.injuryInfo = task.getInjuryInfo()
		this.injuryInfo.span = {
			诊断名称: 24,
			现阶段诊疗方案: 24,
			治疗方式: 24,
			三期诊断库: 24,
		}

		this.accidentInfo = task.getAccidentInfo()
		this.caregiversInfo = task.getCaregiversInfo()
		this.workInfo = task.getWorkInfo()
		this.livingInfo = task.getLivingInfo()
		this.familyInfo = task.getFamilyInfo()
		this.agentInfo = task.getAgentInfo()
		this.caseDelayInfo = task.getCaseDelayInfo()
		this.operatorCancelReasonInfo = task.getOperatorCancelReasonInfo()
		this.operatorCancelHistoryInfo = task.getOperatorCancelHistoryInfo()
	}

	private get supplyInfo() {
		if (['01', '02', '03'].includes(this.order.orderStatus)) {
			if (this.order.returnFlag === '1') {
				return '（待作业人员重新补录）'
			}
			return '（待作业人员补录）'
		}
		return ''
	}

	@Watch('activeKey')
	private onTabsChange() {
		window.scrollTo(0, 0)
	}

	private zeroUnit(val: any, unit: string = '元') {
		if (val === 0 || val) {
			return val + unit
		} else {
			return
		}
	}

	private dateFormat(start: any, end: any) {
		return dateFormat(start, end)
	}

	private soFarDate(date: any) {
		if (date) {
			if (date < SO_FAR) {
				return moment(this.injured.injuredInfo.leaveDate).format('YYYY-MM-DD')
			} else {
				return '至今'
			}
		} else {
			return
		}
	}
}
